import React from "react";

function Footer() {

  const openWindow = (e) => {
    const value = e.target.value;
    window.open(value, "_blank");
  }

  return (
    <footer>
      <div className="wrap">
        <ul>
          <li>
            <h2>
              브랜딩, 디자인 광고 <br />
              <span>올인원 서비스,</span> 코랜
            </h2>
            <p><span>회사명</span>(주)코랜</p>
            <p><span>사업자등록번호</span>619-81-07048</p>
            <p><span>연락처</span>070-4210-8988</p>
            <p><span>이메일</span>info@coren.co.kr</p>
            <p><span>주소</span>대구광역시 수성구 동대구로6길66, 1층</p>
          </li>
          <li>
            <div className="select">
              <select onChange={openWindow}>
                <option value="/">Family Site</option>
                <option value="http://www.corendesign.net/">디자인사업부</option>
                <option value="http://corenfs.com/">푸드스튜디오</option>
                <option value="http://www.corenweb.com/">웹개발팀</option>
                <option value="http://corenmarketing.com/">광고사업부</option>
                <option value="http://corenshopping.com">코랜쇼핑</option>
                <option value="http://corenpet.com">코랜펫</option>
                <option value="http://corenbike.com">코랜바이크</option>
                <option value="http://school.coren.co.kr">코랜스쿨</option>
                <option value="http://jioos.com">지우스</option>
              </select>
              <i className="fa-solid fa-chevron-down"></i>
            </div>

            <div className="sns">
              <a href="#"><img src="/image/home/snsIcon01.png" alt="" /></a>
              <a href="#"><img src="/image/home/snsIcon02.png" alt="" /></a>
              <a href="#"><img src="/image/home/snsIcon03.png" alt="" /></a>
            </div>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
